"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _formatting = require("../formatting"),
    _ref = {},
    languages = _ref.languages,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? "en-US" : _ref$language;

"undefined" != typeof window && (languages = window.navigator.languages, language = window.navigator.language);

function getLang() {
  return void 0 === languages ? language : languages[0];
}

exports.default = function (a) {
  var b,
      c,
      d = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1];
  return b = d ? {
    month: "long"
  } : {
    month: "long",
    year: "numeric"
  }, c = a ? "string" == typeof a ? (0, _formatting.formatOdooDate2Sys)(a) : a : new Date(), c.toLocaleString(getLang(), b);
};